module.exports = {
      id: "bng-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#bng-flag",
      toString: function () {
        return this.url;
      }
    }